"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.supportedTypeMap = void 0;
const collections_1 = require("./beets/collections");
const composites_1 = require("./beets/composites");
const numbers_1 = require("./beets/numbers");
const string_1 = require("./beets/string");
const enums_1 = require("./beets/enums");
const aliases_1 = require("./beets/aliases");
__exportStar(require("./beets/aliases"), exports);
__exportStar(require("./beets/collections"), exports);
__exportStar(require("./beets/string"), exports);
__exportStar(require("./beets/composites"), exports);
__exportStar(require("./beets/enums"), exports);
__exportStar(require("./beets/numbers"), exports);
__exportStar(require("./beet.fixable"), exports);
__exportStar(require("./read-write"), exports);
__exportStar(require("./struct"), exports);
__exportStar(require("./struct.fixable"), exports);
__exportStar(require("./types"), exports);
/**
 * Maps all {@link Beet} de/serializers to metadata which describes in which
 * package it is defined as well as which TypeScript type is used to represent
 * the deserialized value in JavaScript.
 *
 * @category TypeDefinition
 */
exports.supportedTypeMap = {
    ...collections_1.collectionsTypeMap,
    ...string_1.stringTypeMap,
    ...composites_1.compositesTypeMap,
    ...enums_1.enumsTypeMap,
    ...numbers_1.numbersTypeMap,
    ...aliases_1.aliasesTypeMap,
};
//# sourceMappingURL=beet.js.map